<template>
  <v-dialog v-model="showDay" max-width="300px" persistent>
    <v-card>
      <v-card-title class="d-flex justify-center">
        {{ $tc("monitor.addDay") }}
      </v-card-title>
      <DateWithCheck :showCheck="false" :showDateTo="false" class="my-3 mx-4" />
      <div class="d-flex justify-space-between pa-4">
        <v-btn @click="closeDayDialog" class="bt-exit">
          {{ $tc("commons.cancel") }}
        </v-btn>
        <v-btn @click="confirmDay" class="bt-acept">
          {{ $tc("commons.accept") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import DateWithCheck from "../Complement/DateWithCheck.vue";
export default {
  components: {
    DateWithCheck,
  },
  props: {
    showDay: Boolean,
    closeDayDialog: Function,
    confirmDay: Function,
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
